export default "__VITE_ASSET__77308527__"